module.exports = __webpack_public_path__ + "img/help_data_unsave.8ac4456b.png";